export class LocalStorage {
  static set(key: string, data: string) {
    window.sessionStorage.setItem(key, data);
  }

  static get(key: string) {
    return window.sessionStorage.getItem(key);
  }

  static remove(key: string) {
    return window.sessionStorage.removeItem(key);
  }
}
